<template>
  <b-tab title="Guarantors">
    <div class="bg-extra-light-gray rounded section-title">
      <h6 class="mb-0">Guarantors</h6>
      <b-button variant="primary" size="sm" @click="addGuarantor">
        <i class="fa fa-plus"></i>
      </b-button>
    </div>

    <div class="section-body">
      <b-row>
        <b-col>
          <div v-if="guarantorItems.length">
            <data-card
              v-for="(guarantor, guarantorIndex) in guarantorItems"
              :cardInfo="guarantor"
              :key="guarantorIndex"
              @edit-item="editGuarantor(guarantor)"
              @delete-item="deleteGuarantor(guarantor)"
            />
          </div>

          <div v-else class="d-flex justify-content-center color-custom-grey">
            No guarantor information.
          </div>

          <guarantor-form
            v-if="guarantorModalShow"
            v-model="guarantorModalShow"
            @onModify="onModifyAddGuarantor"
            @ok="submitGuarantor"
            :guarantor="formGuarantor"
            :guarantors="guarantors"
            :patientInfo="patientInfo"
          >
          </guarantor-form>
        </b-col>
      </b-row>
    </div>
  </b-tab>
</template>

<script>
import guarantorForm from "../PatientGuarantorForm";
import DataCard from "../../controls/DataCard";

export default {
  name: "EocPortalGuarantors",
  components: {
    guarantorForm,
    DataCard
  },
  props: {
    patientId: {
      type: String,
      default: ""
    },
    guarantors: {
      type: Array
    },
    patientInfo: {
      type: Object
    }
  },
  data() {
    return {
      formGuarantor: null,
      guarantorModalShow: false
    };
  },
  methods: {
    addGuarantor() {
      this.formGuarantor = null;
      this.guarantorModalShow = true;
    },
    editGuarantor(record) {
      this.formGuarantor = {
        itemIndex: record.itemIndex,
        oldEmail: record.data.email,
        ...record.data
      };
      this.guarantorModalShow = true;
    },
    onModifyAddGuarantor() {
      this.guarantorModalShow = false;
    },
    deleteGuarantor(record) {
      this.$dialog
        .confirm(
          { title: "Are you sure you want to delete this record?" },
          { view: "confirm-delete" }
        )
        .then(async () => {
          this.guarantors.splice(record.itemIndex, 1);
          this.$emit("update:guarantors", this.guarantors);
        })
        .catch(function() {});
    },
    submitGuarantor(data) {
      if (typeof data.itemIndex == "number") {
        this.guarantors.splice(data.itemIndex, 1, data);
      } else {
        this.guarantors.push(data);
      }
      this.guarantorModalShow = false;
      this.$emit("update:guarantors", this.guarantors);
    },
    buildAddress(item) {
      const arr = [];
      if (item.address) arr.push(item.address);
      if (item.city) arr.push(item.city);
      if (item.state) arr.push(item.state.name);
      if (item.zipCode) arr.push(item.zipCode);
      return arr.join(", ");
    }
  },
  computed: {
    guarantorItems() {
      return this.guarantors.map((item, itemIndex) => {
        const data = {
          itemIndex,
          data: item,
          title:
            item?.firstName + " " + item?.middleName + " " + item?.lastName,
          extraData: [
            [
              ...(item?.relationship
                ? [`Relationship: ${item?.relationship.name}`]
                : []),
              ...(item.phone ? [`Mobile Phone: ${item.phone}`] : []),
              ...(item?.email ? [`Email: ${item?.email}`] : [])
            ]
          ]
        };

        const address = this.buildAddress(item);
        if (address) {
          data.extraData.push([`Address: ${address}`]);
        }

        return data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 63px;
  padding: 1rem;
  margin-top: 15px;
  margin-bottom: 15px;
}
.section-body {
  min-height: 70px;
}
</style>
